import React, { useEffect, useState } from 'react';
import {
  getImpuestos, crearImpuesto, editarImpuesto, eliminarImpuesto,
  getMonedas, crearMoneda, editarMoneda, eliminarMoneda,
} from '../services/api';

const TIPOS = ['IVA', 'RETEFUENTE', 'RETEICA', 'RETEIVA', 'INC'];
const TIPO_COLOR = { IVA: '#3b82f6', RETEFUENTE: '#f59e0b', RETEICA: '#8b5cf6', RETEIVA: '#10b981', INC: '#ef4444' };
const IMP0 = { tipo: 'IVA', nombre: '', tarifa: '', base_minima: 0, cuenta_contable: '' };
const MON0 = { codigo: '', nombre: '', simbolo: '', es_base: false };

export default function ImpuestosMonedas() {
  const [tab, setTab] = useState('impuestos');
  const [imps, setImps] = useState([]);
  const [mons, setMons] = useState([]);
  const [modal, setModal] = useState(null); // 'imp' | 'mon'
  const [fImp, setFImp] = useState(IMP0);
  const [fMon, setFMon] = useState(MON0);
  const [err, setErr] = useState('');

  const load = () => { getImpuestos().then(r => setImps(r.data)).catch(() => {}); getMonedas().then(r => setMons(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, []);

  const saveImp = async () => {
    if (!fImp.nombre || fImp.tarifa === '') return setErr('Nombre y tarifa requeridos');
    try { fImp.id ? await editarImpuesto(fImp.id, fImp) : await crearImpuesto(fImp); setModal(null); load(); }
    catch (e) { setErr(e.response?.data?.error || 'Error'); }
  };
  const saveMon = async () => {
    if (!fMon.codigo) return setErr('El código es requerido');
    try { fMon.id ? await editarMoneda(fMon.id, fMon) : await crearMoneda(fMon); setModal(null); load(); }
    catch (e) { setErr(e.response?.data?.error || 'Error'); }
  };
  const delImp = async (x) => { if (window.confirm(`¿Eliminar "${x.nombre}"?`)) { await eliminarImpuesto(x.id); load(); } };
  const delMon = async (x) => { if (x.es_base) return alert('No se puede eliminar la moneda base'); if (window.confirm(`¿Eliminar "${x.codigo}"?`)) { await eliminarMoneda(x.id); load(); } };

  return (
    <div>
      <div style={s.header}><div><h1 style={s.h1}>Monedas e impuestos</h1><p style={s.sub}>Catálogo de tarifas y monedas del sistema</p></div>
        <button style={s.btnPrimary} onClick={() => { setErr(''); if (tab === 'impuestos') { setFImp(IMP0); setModal('imp'); } else { setFMon(MON0); setModal('mon'); } }}>
          + {tab === 'impuestos' ? 'Nuevo impuesto' : 'Nueva moneda'}</button>
      </div>

      <div style={s.tabs}>
        <button style={{ ...s.tab, ...(tab === 'impuestos' ? s.tabOn : {}) }} onClick={() => setTab('impuestos')}>Impuestos ({imps.length})</button>
        <button style={{ ...s.tab, ...(tab === 'monedas' ? s.tabOn : {}) }} onClick={() => setTab('monedas')}>Monedas ({mons.length})</button>
      </div>

      {tab === 'impuestos' ? (
        <div style={s.card}><table style={s.table}>
          <thead><tr>{['Tipo', 'Nombre', 'Tarifa', 'Base mínima', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {imps.length === 0 && <tr><td colSpan={5} style={s.empty}>Sin impuestos.</td></tr>}
            {imps.map(x => (
              <tr key={x.id}>
                <td style={s.td}><span style={{ ...s.chip, background: (TIPO_COLOR[x.tipo] || '#64748b') + '22', color: TIPO_COLOR[x.tipo] || '#94a3b8' }}>{x.tipo}</span></td>
                <td style={{ ...s.td, color: '#e2e8f0' }}>{x.nombre}</td>
                <td style={{ ...s.td, fontWeight: 700, fontFamily: 'ui-monospace' }}>{Number(x.tarifa)}%</td>
                <td style={s.td}>{Number(x.base_minima) ? '$' + Number(x.base_minima).toLocaleString('es-CO') : '—'}</td>
                <td style={s.td}><button style={s.link} onClick={() => { setErr(''); setFImp({ ...IMP0, ...x }); setModal('imp'); }}>Editar</button>
                  <button style={{ ...s.link, color: '#fca5a5' }} onClick={() => delImp(x)}>Eliminar</button></td>
              </tr>
            ))}
          </tbody>
        </table></div>
      ) : (
        <div style={s.card}><table style={s.table}>
          <thead><tr>{['Código', 'Nombre', 'Símbolo', 'Base', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {mons.map(x => (
              <tr key={x.id}>
                <td style={{ ...s.td, fontWeight: 700, color: '#93c5fd' }}>{x.codigo}</td>
                <td style={{ ...s.td, color: '#e2e8f0' }}>{x.nombre || '—'}</td>
                <td style={s.td}>{x.simbolo || '—'}</td>
                <td style={s.td}>{x.es_base ? <span style={s.badge}>Base</span> : '—'}</td>
                <td style={s.td}><button style={s.link} onClick={() => { setErr(''); setFMon({ ...MON0, ...x }); setModal('mon'); }}>Editar</button>
                  {!x.es_base && <button style={{ ...s.link, color: '#fca5a5' }} onClick={() => delMon(x)}>Eliminar</button>}</td>
              </tr>
            ))}
          </tbody>
        </table></div>
      )}

      {modal === 'imp' && (
        <div style={s.overlay}><div style={s.modal}>
          <div style={s.modalHeader}><h2 style={s.modalTitle}>{fImp.id ? 'Editar impuesto' : 'Nuevo impuesto'}</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
          <div style={s.modalBody}>
            <div style={s.row2}>
              <div style={s.field}><label style={s.label}>Tipo</label>
                <select style={s.input} value={fImp.tipo} onChange={e => setFImp({ ...fImp, tipo: e.target.value })}>{TIPOS.map(t => <option key={t} value={t}>{t}</option>)}</select></div>
              <div style={s.field}><label style={s.label}>Tarifa (%)</label>
                <input style={s.input} type="number" step="0.001" value={fImp.tarifa} onChange={e => setFImp({ ...fImp, tarifa: e.target.value })} /></div>
            </div>
            <div style={s.field}><label style={s.label}>Nombre</label>
              <input style={s.input} value={fImp.nombre} placeholder="Ej: IVA 19%" onChange={e => setFImp({ ...fImp, nombre: e.target.value })} /></div>
            <div style={s.row2}>
              <div style={s.field}><label style={s.label}>Base mínima (opcional)</label>
                <input style={s.input} type="number" value={fImp.base_minima} onChange={e => setFImp({ ...fImp, base_minima: e.target.value })} /></div>
              <div style={s.field}><label style={s.label}>Cuenta contable (opcional)</label>
                <input style={s.input} value={fImp.cuenta_contable || ''} onChange={e => setFImp({ ...fImp, cuenta_contable: e.target.value })} /></div>
            </div>
            {err && <div style={s.error}>{err}</div>}
          </div>
          <div style={s.modalFooter}><button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button><button style={s.btnPrimary} onClick={saveImp}>Guardar</button></div>
        </div></div>
      )}

      {modal === 'mon' && (
        <div style={s.overlay}><div style={s.modal}>
          <div style={s.modalHeader}><h2 style={s.modalTitle}>{fMon.id ? 'Editar moneda' : 'Nueva moneda'}</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
          <div style={s.modalBody}>
            <div style={s.row2}>
              <div style={s.field}><label style={s.label}>Código (ISO)</label>
                <input style={s.input} value={fMon.codigo} placeholder="COP, USD…" onChange={e => setFMon({ ...fMon, codigo: e.target.value.toUpperCase() })} /></div>
              <div style={s.field}><label style={s.label}>Símbolo</label>
                <input style={s.input} value={fMon.simbolo} placeholder="$" onChange={e => setFMon({ ...fMon, simbolo: e.target.value })} /></div>
            </div>
            <div style={s.field}><label style={s.label}>Nombre</label>
              <input style={s.input} value={fMon.nombre} placeholder="Peso colombiano" onChange={e => setFMon({ ...fMon, nombre: e.target.value })} /></div>
            <div style={{ marginTop: 6, padding: '10px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', color: '#cbd5e1', fontSize: 13 }}>
                <input type="checkbox" checked={!!fMon.es_base} onChange={e => setFMon({ ...fMon, es_base: e.target.checked })} /> Moneda <b>base</b> del sistema</label>
            </div>
            {err && <div style={s.error}>{err}</div>}
          </div>
          <div style={s.modalFooter}><button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button><button style={s.btnPrimary} onClick={saveMon}>Guardar</button></div>
        </div></div>
      )}
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  sub: { color: '#64748b', fontSize: 14, margin: '4px 0 0' },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnSecondary: { background: '#334155', color: '#cbd5e1', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  tabs: { display: 'flex', gap: 8, marginBottom: 16, borderBottom: '1px solid #334155' },
  tab: { background: 'none', border: 'none', color: '#94a3b8', padding: '10px 16px', fontSize: 14, cursor: 'pointer', borderBottom: '2px solid transparent' },
  tabOn: { color: '#f1f5f9', borderBottom: '2px solid #4f46e5', fontWeight: 600 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { background: '#0f172a', color: '#94a3b8', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.5px', padding: '10px 14px', textAlign: 'left' },
  td: { padding: '10px 14px', color: '#cbd5e1', borderBottom: '1px solid #1a2332' },
  empty: { padding: 24, textAlign: 'center', color: '#64748b' },
  chip: { fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4 },
  badge: { fontSize: 10, color: '#34d399', border: '1px solid #34d39955', borderRadius: 4, padding: '1px 6px' },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, padding: 0, marginRight: 12 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', borderRadius: 16, width: '92%', maxWidth: 520, border: '1px solid #334155', display: 'flex', flexDirection: 'column' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 22px', borderBottom: '1px solid #334155' },
  modalTitle: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: 0 },
  closeBtn: { background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer' },
  modalBody: { padding: '18px 22px' },
  modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 22px', borderTop: '1px solid #334155' },
  row2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  field: { display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 },
  label: { color: '#94a3b8', fontSize: 12 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, height: 40, padding: '0 11px', color: '#f1f5f9', fontSize: 13, width: '100%', boxSizing: 'border-box' },
  error: { background: '#450a0a', border: '1px solid #b91c1c', color: '#fca5a5', padding: '8px 12px', borderRadius: 8, marginTop: 8, fontSize: 13 },
};
